module.exports = __webpack_public_path__ + "img/8.bb5ed94a.png";